import { createSagaAction } from '../../shared/sagas';
import { createReducer } from '../../shared/reducers';

import { PromotionalVideo } from '../../types/promotionalVideo';

export type PromotionalVideoState = {
  data: PromotionalVideo | null;
  isLoading: boolean;
  error: string | null;
};

// Constants
export const constants = {
  PROMOTIONAL_VIDEO_GET: createSagaAction('PROMOTIONAL_VIDEO_GET'),
};

// Actions
export const actions = {
  getPromotionalVideo: () => ({
    type: constants.PROMOTIONAL_VIDEO_GET.ACTION,
  }),
};

// Action Handlers
const ACTION_HANDLERS = {
  [constants.PROMOTIONAL_VIDEO_GET.ACTION]: (state: PromotionalVideoState) => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [constants.PROMOTIONAL_VIDEO_GET.SUCCESS]: (
    state: PromotionalVideoState,
    action: { payload: PromotionalVideo | null }
  ) => ({
    ...state,
    data: action.payload,
    isLoading: false,
    error: null,
  }),
  [constants.PROMOTIONAL_VIDEO_GET.FAILED]: (
    state: PromotionalVideoState,
    action: { message: string }
  ) => ({
    ...state,
    isLoading: false,
    error: action.message,
  }),
};

// Initial State
export const initialState: PromotionalVideoState = {
  data: null,
  isLoading: false,
  error: null,
};

// Reducer
export default createReducer(initialState, (state: PromotionalVideoState, action: any) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
});
